/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { DialogActions, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
const DocumentEditDialogTopActions = () => {
    const { t }  = useTranslation();
    const {
        selectedDocEditTab,
        setSelectedDocEditTab
    } = useContext(DocumentEditContext);
    const handleTabsChange = (event, newValue) => {
        switch (newValue) {
            case 0:
                setSelectedDocEditTab(newValue);
                break;
            case 1:
                setSelectedDocEditTab(newValue);
                break;
            case 2:
                setSelectedDocEditTab(newValue);
                break;
            default:
                break;
        }
    };
    return (
        <Fragment>
            <DialogActions
                className="simplicity-doc-selector-window-tabs edit-doc-window-tabs"
                style={{  }}
            >
                <Tabs value={selectedDocEditTab} onChange={handleTabsChange} aria-label="edit tabs">
                    <Tab label={t("commons.details")} id='tabpanel-1' aria-controls='tabpanel-1' />
                    <Tab label={t("commons.recordsManagement")} id='tabpanel-2' aria-controls='tabpanel-2' />
                    <Tab label={t("commons.placements")} id='tabpanel-3' aria-controls='tabpanel-3' />
                </Tabs>
            </DialogActions>
        </Fragment>
    );
};
export { DocumentEditDialogTopActions };
